import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

import { Stores } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';

import { AppStore } from 'stores';

interface ProductStores extends Stores {
  analytics: AnalyticsStore;
  app: AppStore;
}

function useStores(): ProductStores {
  return useContext(MobXProviderContext) as ProductStores;
}

export { ProductStores, useStores };
